/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Content_SubtitleInputs */

const en_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free use of trees updated every season!`)
};

const ar_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدام مجاني للأشجار التي يتم تحديثها كل موسم!`)
};

const de_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlose Nutzung von Bäumen, die zu jeder Jahreszeit aktualisiert werden!`)
};

const es_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Uso gratuito de árboles actualizados cada temporada!`)
};

const fr_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès libre aux arbres, mis à jour à chaque saison !`)
};

const it_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzo gratuito di alberi aggiornati ogni stagione!`)
};

const ja_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンごとに更新される樹種を無料でご利用いただけます！`)
};

const ko_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시즌마다 업데이트되는 나무를 무료로 사용하세요!`)
};

const pt_br_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso gratuito de árvores atualizado a cada temporada!`)
};

const ru_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатное использование деревьев, обновляемых каждый сезон!`)
};

const th_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใช้ต้นไม้ฟรี อัปเดตทุกฤดูกาล!`)
};

const tr_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her mevsim güncellenen ağaçların ücretsiz kullanımı!`)
};

const zh_cn_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费使用每一季更新的树种`)
};

const zh_tw_subscription_exclusive_content_subtitle = /** @type {(inputs: Subscription_Exclusive_Content_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免費使用每一季更新的樹種`)
};

/**
* | output |
* | --- |
* | "Free use of trees updated every season!" |
*
* @param {Subscription_Exclusive_Content_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content_subtitle = /** @type {((inputs?: Subscription_Exclusive_Content_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Content_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content_subtitle(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content_subtitle(inputs)
	if (locale === "de") return de_subscription_exclusive_content_subtitle(inputs)
	if (locale === "es") return es_subscription_exclusive_content_subtitle(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content_subtitle(inputs)
	if (locale === "it") return it_subscription_exclusive_content_subtitle(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content_subtitle(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content_subtitle(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content_subtitle(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content_subtitle(inputs)
	if (locale === "th") return th_subscription_exclusive_content_subtitle(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content_subtitle(inputs)
	return zh_tw_subscription_exclusive_content_subtitle(inputs)
});